const GoogleMapConfig = {
  key: 'AIzaSyDbO6fP2AC8RnVKQorb4iT3s3JyXJmCubA',
}

export default GoogleMapConfig;
